export default "/_next/static/images/img1-dcc129fe35442a52faf2e5f111cf5616.png";